import { get, post, put, postPublic } from "../data/api";
import { getToken, redirectToLogin } from "../data/auth.service";

export async function register(params) {
    let reg = {
        Email: params.registerEmail,
        Password: params.registerPwd,
        Firstname: params.registerFname,
        Lastname: params.registerLname

    };
    var data = await postPublic(reg, 'authenticate/register')

    if (data) {
        localStorage.setItem("user", JSON.stringify(data.user))
        localStorage.setItem("holidaysMode", JSON.stringify(data.holidaysMode))
    }
    return data;

}
export async function switchHolidaysMode() {

    return await put(null, 'account/holidaysMode')
}

export async function getHolidaysMode() {
    return await get('account/holidaysMode')
}

// { enabled, startDate: "yyyy-MM-dd"|null, endDate: "yyyy-MM-dd"|null }
export async function setHolidaysMode(params) {
    return await put(params, 'account/holidaysMode')
}

export async function createOnStripe() {
    let p = {};
    return await post(p, 'account/create-stripe')
}

export async function update(params) {
    const isProfessional = params.isProfessional === true || params.isProfessional === "true" || params.IsProfessional === true || params.IsProfessional === "true";
    let reg = {
        Email: params.email,
        CurrentPassword: params.currentPwd,
        NewPassword: params.newPwd,
        Firstname: params.fname,
        Lastname: params.lname,
        Address: params.address,
        Zipcode: params.zipcode,
        City: params.city,
        Phone: params.phone,
        IsProfessional: isProfessional,
        CompanyName: params.companyName,
        Siret: params.siret,
        VatNumber: params.vatNumber,
        SmtpHost: params.smtpHost,
        SmtpPort: params.smtpPort,
        MailCredentialsUserName: params.mailCredentialsUserName,
        MailCredentialsPwd: params.mailCredentialsPwd,
    };

    return await put(reg, 'account/')
}
export async function getAccount() {
    return await get('account/')
}

export async function getUserSettings() {
    return await get('account/settings')
}

export async function updateUserSettings(params) {
    return await put(params, 'account/settings')
}

export async function testClientEmailTemplate(key, params) {
    return await post(params, `account/settings/email-template-test/${key}`)
}

export async function testContractTemplate(params) {
    const response = await fetch("/api/account/settings/contract-template-test", {
        method: "POST",
        headers: {
            "Content-type": "application/json",
            Authorization: "Bearer " + getToken()
        },
        body: JSON.stringify(params)
    });

    if (response.status === 401) {
        redirectToLogin();
        return null;
    }

    if (!response.ok) {
        const text = await response.text();
        try {
            const data = JSON.parse(text);
            throw new Error(data.message || data.Message || "Impossible de générer le contrat de test.");
        } catch (error) {
            if (error instanceof SyntaxError) {
                throw new Error(text || "Impossible de générer le contrat de test.");
            }
            throw error;
        }
    }

    const contentDisposition = response.headers.get("content-disposition") || "";
    const filenameMatch = contentDisposition.match(/filename\*?=(?:UTF-8''|")?([^";]+)/i);
    return {
        blob: await response.blob(),
        filename: filenameMatch ? decodeURIComponent(filenameMatch[1].replace(/"/g, "")) : "contrat_test.pdf"
    };
}

export async function testUpcomingRentalNotification() {
    return await post({}, "account/settings/upcoming-rental-notification-test")
}

export async function getProviderSettings() {
    return await get('account/provider-settings')
}
